<ng-container *transloco="let t">
  <div class="form-container">
    <img src="assets/logo.png" alt="Logo" class="logo" />

    <div class="form-content">
      <h1>{{ t("performSignup") }}</h1>
      <p>
        {{ t("gotAccountQuestion") }}
        <a class="highlighted" routerLink="/login">
          {{ t("goToLogin") }}
        </a>
      </p>

      <form
        class="form"
        #signupForm="ngForm"
        (keydown.enter)="signupForm.valid && consents.privacyPolicy && signup()"
      >
        <p-floatlabel variant="in" class="email-input">
          <input
            pInputText
            [(ngModel)]="authData.email"
            id="email-signup"
            autocomplete="off"
            name="email"
            required
          />
          <label for="email-signup">{{ t("email") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in" class="username-input">
          <input
            pInputText
            [(ngModel)]="authData.username"
            id="username-signup"
            autocomplete="off"
            name="username"
            required
          />
          <label for="username-signup">{{ t("username") }}</label>
        </p-floatlabel>

        <p
          class="password-descriptor"
          [innerHTML]="t('passwordRequisites')"
        ></p>
        <p-floatlabel variant="in" class="password-input">
          <p-password
            [(ngModel)]="authData.password"
            inputId="password-signup"
            name="password"
            required
            [toggleMask]="true"
            [feedback]="true"
            [mediumRegex]="mediumRegex"
            [strongRegex]="strongRegex"
            appendTo="body"
          />
          <label for="password-signup">{{ t("password") }}</label>
        </p-floatlabel>

        <!-- <p-floatlabel variant="in" class="first-name-input">
          <input
            pInputText
            [(ngModel)]="authData.firstName"
            id="first-name-signup"
            autocomplete="off"
            name="first-name"
            required
          />
          <label for="first-name-signup">{{ t("firstName") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in" class="last-name-input">
          <input
            pInputText
            [(ngModel)]="authData.lastName"
            id="last-name-signup"
            autocomplete="off"
            name="last-name"
            required
          />
          <label for="last-name-signup">{{ t("lastName") }}</label>
        </p-floatlabel> -->

        <p-floatlabel variant="in">
          <p-select
            inputId="gender-signup"
            name="gender"
            [(ngModel)]="authData.gender"
            autocomplete="off"
            [options]="[
              { label: t('male'), value: 'M' },
              { label: t('female'), value: 'F' },
              { label: t('otherOrUnspecified'), value: 'O' },
            ]"
            appendTo="body"
            styleClass="w-full"
            required
          />
          <label for="gender-signup">
            {{ t("gender") }}
          </label>
        </p-floatlabel>

        <div class="checkbox-container">
          <p-checkbox
            name="privacyPolicy"
            [(ngModel)]="consents.privacyPolicy"
            [binary]="true"
            inputId="privacy-policy-signup"
            required
          />
          <label for="privacy-policy-signup"
            ><span [innerHTML]="t('privacyPolicyConsentLabel')"></span
          ></label>
        </div>
      </form>

      <p-button
        [label]="t('signup')"
        (click)="signup()"
        class="signup-button"
        size="large"
        icon="pi pi-user-plus"
        [disabled]="
          signupForm.invalid || !consents.privacyPolicy
        "
      />
    </div>
  </div>

  <div class="illustration-container">
    <img src="assets/login-image.jpeg" alt="Bike sharing" />
  </div>
</ng-container>
